import React from "react";
// import "../../styles/components-styles/question-components-styles/ReviewHeader.css";
import "../../styles/components-styles/question-components-styles/ReviewHeader.css"

const ReviewHeader = () => {
  return (
    <div className="app-header">
      <h1>Review questions and key concepts</h1>
      <div className="header-tabs">
        <div className="tab-container">
          <button className="tab-button active">Questions</button>
          <button className="tab-button">Key concepts</button>
        </div>
        <div className="search-container">
          <input type="text" placeholder="Search..." className="search-input" />
          <button className="search-button">Go</button>
        </div>
        <div className="sort-container">
          <button className="sort-button active">Sort by date</button>
          <button className="sort-button">Sort alphabetically</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewHeader;
